module.exports = __webpack_public_path__ + "media/כפתור.9201bb66.mp3";